import { Button } from "@material-ui/core";
import { WithStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import * as React from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import { buttonOffset } from "src/features/home/pages/Home";
import { ILogin } from "src/api/types";
import Component from "./Component";
import GoogleCallback from "./Signup/GoogleCallback";
import { AppContextConsumer, IAppContext } from "./withAppContext";
import withAxios, { IAxiosProps } from "./withAxios";
import GoogleLogo from "src/assets/2702602.png";
import EmailIcon from '@material-ui/icons/Email'; 
import "src/features/home/pages/signUp-pages/style.css";
const styles = () => ({
  text: {
    color: "white",
  },
});

interface ILoginFormState {
  error: boolean;
  submitting: boolean;
}

type IProps = IAppContext &
  IAxiosProps &
  WithStyles<keyof ReturnType<typeof styles>>;

const GoogleSignUpForm = withStyles(styles)(
  withAxios(
    class extends Component<IProps, ILoginFormState> {
      public readonly state: Readonly<ILoginFormState> = {
        error: false,
        submitting: false,
      };

      public render() {
        const { classes } = this.props;
        const { error, submitting } = this.state;
        if (submitting) {
          return <Typography className={classes.text}>Submitting…</Typography>;
        }
        return (
          <form>
            {error && (
              <Typography style={{color:"red",marginBottom:"5px"}} className={classes.text}>
                There was an error.
              </Typography>
            )}
            <Switch>
              <Route
                path="/sign-up/google/callback"
                render={this.renderGoogleCallback}
              />
              <Route path="/sign-up" render={this.renderGoogleButton} />
            </Switch>
          </form>
        );
      }

      private renderGoogleButton = () => {
        return (
          <>

            <Button
              className="button-signup"
              variant="contained"
              color="primary"
              onClick={this.handleGoogleClick}
              style={{ marginLeft: buttonOffset }}
            >
              <img src={GoogleLogo} style={{ marginRight: "10px" }} />
              Sign up with Google
            </Button>
            <div style={{marginTop:"10px"}}>
            <Button
              className="button-signup"
              variant="contained"
              color="primary"
              style={{ marginLeft: buttonOffset,marginBottom:"35px" }}
              onClick={() => { window.location.href = "/email/password" }}
            >
                           <EmailIcon style={{ marginRight: "10px" }}/>
              Sign up with Email
            </Button>
            </div>
          </>
        );
      };

      private handleGoogleClick = () =>
        void this.runCancellableStatefulAsync(
          this,
          {
            error: false,
            submitting: true,
          },
          {
            submitting: false,
          },
          async () => {
            sessionStorage.setItem("isFirstVisit", "true");
            const response = await this.buildGet<ILogin>(
              this,
              "sign-up/google"
            )();
            location.href = response.url;
          },
          () => {
            this.setState({
              error: true,
              submitting: false,
            });
          }
        );

      private renderGoogleCallback = (props: RouteComponentProps<any>) => {
        return (
          <Typography className={this.props.classes.text}>
            <GoogleCallback {...props} {...this.props} />
          </Typography>
        );
      };
    }
  )
);

export default () => (
  <AppContextConsumer>
    {(context) => <GoogleSignUpForm {...context} />}
  </AppContextConsumer>
);



// WEBPACK FOOTER //
// ./src/shared/components/GoogleSignupForm.tsx